package compose.assets.svg

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.addPathNodes
import androidx.compose.ui.unit.dp
import compose.assets.Svg

// Material Design Icons: help-circle-outline
public val Svg.Help_circle_outline: ImageVector
    get() {
        if (_help_circle_outline != null) {
            return _help_circle_outline!!
        }
        _help_circle_outline = ImageVector.Builder(
            name = "Help_circle_outline",
            defaultWidth = 24.0.dp,
            defaultHeight = 24.0.dp,
            viewportWidth = 24.0f,
            viewportHeight = 24.0f
        ).addPath(
            pathData = addPathNodes("M11,18H13V16H11V18M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,6A4,4 0 0,0 8,10H10A2,2 0 0,1 12,8A2,2 0 0,1 14,10C14,12 11,11.75 11,15H13C13,12.75 16,12.5 16,10A4,4 0 0,0 12,6Z"),
            fill = SolidColor(Color(0xFF000000))
        ).build()
        return _help_circle_outline!!
    }

private var _help_circle_outline: ImageVector? = null
